<template>
<nav class="page-navigation" aria-label="Page navigation">
    <ul class="pagination justify-content-center">
        <li class="page-item icon" :class="{disabled: !this.ShowFirst}">
            <a class="page-link" tabindex="-1" :href="PageUrl(1)" v-on:click.prevent="ChangePage(1)" aria-label="Primeira página">
                <i class="fas fa-angle-double-left"></i><span>Primeira</span>
            </a>
        </li>
        <li class="page-item icon" :class="{disabled: !this.ShowPrevious}">
            <a class="page-link" tabindex="-1" :href="PageUrl(PageNum-1)" v-on:click.prevent="ChangePage(PageNum-1)" aria-label="Página anterior">
                <i class="fas fa-angle-left"></i><span>Anterior</span>
            </a>
        </li>
        <li v-for="p in Pages" :key="p" v-on:click.prevent="ChangePage(p.Num)" class="page-item" :class="p.class" aria-current="page">
            <a class="page-link" :href="PageUrl(p.Num)">{{p.Label}}</a>
        </li>
        
        <li class="page-item icon" :class="{disabled: !this.ShowNext}">
            <a class="page-link" tabindex="-1" :href="PageUrl(PageNum+1)" aria-label="Página seguinte" v-on:click.prevent="ChangePage(PageNum+1)"><span>Seguinte</span><i class="fas fa-angle-right"></i></a>
        </li>
        <li class="page-item icon" :class="{disabled: !this.ShowLast}">
            <a class="page-link" tabindex="-1" :href="PageUrl(TotalPages)" v-on:click.prevent="ChangePage(TotalPages)" aria-label="Última página">
                <span>Última</span><i class="fas fa-angle-double-right"></i>
            </a>
        </li>
    </ul>
    <p v-if="!noResult" class="result">Pág. {{this.PageNum}} de {{(this.TotalPages) || toCurrency}} / {{this.Total || toCurrency}} {{ this.ItemType }}</p>
</nav>
</template>

<script>

export default {

    name: "pagination",
    props: {
        PageSize: { type: Number, required: true, default: 48 },
        PageNum: { type: Number, required: true, default: 1 },
        Total: { type: Number, default: 0 },
        PagesOffset: { type: Number, default: 3 },
        dbg: { type: Boolean, default: false },
        ItemType: {type: String, default: "viaturas"}
    },
    data() {
        return {
            ShowPrevious: false,
            ShowNext: false,
            ShowFirst: false,
            ShowLast: false
        };
    },
    computed: {
        TotalPages: function () {
            return Math.ceil(this.Total / this.PageSize);
        },
        Pages: function () {
            this.ShowPrevious = false;
            this.ShowNext = false;
            this.ShowFirst = false;
            this.ShowLast = false;

            let result = [];

            if (this.TotalPages > 0) {
                    let start = this.PageNum - this.PagesOffset;
                    let end = this.PageNum + this.PagesOffset;

                    if (start < 1) {
                        let diff = 1 - start;
                        if (diff > 0) {
                            end += diff;
                            start -= diff;
                        }
                    }
                    if (end > this.TotalPages) {
                        let diff = end - this.TotalPages;
                        if (diff > 0) {
                            start -= diff;
                            end -= diff;
                        }
                    }

                    if (start < 1) start = 1;
                    if (end > this.TotalPages) end = this.TotalPages;

                    for (let p = start; p <= end; p++) {
                        result.push(this.CreatePageItem(p));
                    }

                    if (this.PageNum > 1) {
                        this.ShowPrevious = true;
                    }
                    if (this.PageNum > 1) {
                        this.ShowFirst = true;
                    }
                    if (this.PageNum < this.TotalPages) {
                        this.ShowNext = true;
                    }
                    if (this.PageNum < this.TotalPages) {
                        this.ShowLast = true;
                    }
            }

            this.$emit('update', { PageNum: this.PageNum, TotalPages: this.TotalPages, PageSize: this.PageSize, });

            return result;
        }
    },
    methods: {
        ChangePage(pNum) {
            if (pNum == this.PageNum) return;
            this.PageNum = pNum;
            this.$emit("OnPageChange", { PageNum: +pNum, PageSize: +this.PageSize });
            this.$root.$emit("OnPageChange", { PageNum: +pNum, PageSize: +this.PageSize });
        },
        CreatePageItem: function (num, label) {
            let r = { Num: num, Label: label, Current: (num === this.PageNum) };
            if (r.Label === undefined || r.Label === null) {
                r.Label = r.Num;
            }
            if (num === this.PageNum) r.class = "active";
            return r;
        },
        PageUrl:function (pNum){            
            var params = new URLSearchParams(window.location.search);
            params.set("p", pNum);
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?${params.toString()}`;            
            return newurl;
        }
    }
};
</script>